export default "__VITE_ASSET__BVq0QRLQ__"